export const formatTRY = (num) =>
    Number(num || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';

export const CURRENCY_SYMBOLS = { TRY: '₺', USD: '$', EUR: '€', GBP: '£' };

/**
 * Tutarı verilen para birimiyle biçimler. Ödeme linki tutarları linkin para biriminde
 * saklanır (döviz linklerde TL karşılığı ödeme anında kurla hesaplanır), bu yüzden
 * listeleme/detay ekranları sabit ₺ yerine bunu kullanmalıdır.
 * Para birimi boş/bilinmiyorsa TRY varsayılır — eski kayıtlar bozulmaz.
 */
export const formatAmountWithCurrency = (value, currency) => {
    if (value === null || value === undefined || value === '') return '-';
    const n = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(n)) return '-';
    const symbol = CURRENCY_SYMBOLS[(currency || 'TRY').toUpperCase()] || CURRENCY_SYMBOLS.TRY;
    return `${symbol} ${n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
